define(["./nodeCommandsModule"], function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("calculateExternalFreightCommand", [
        "externalFreightService",
        function (externalFreightService) {
            return function (selection, context) {
                if (selection && selection.length > 0) {
                    return externalFreightService.calculateFreightUrlForNodeIdentifier(selection, context);
                }
            };
        }
    ]);
});